import Constants from '../../../app/utils/constants'
import QuestionItem from '../../atoms/QuestionItem/QuestionItem'
import type { SectionTheme } from '../../theme/sectionTheme'
import { useState } from 'react'

type QuestionsThemeColor = 'purple' | 'green' | 'rabbitx' | 'arbventure' | 'tatvacaretheme' | 'ddxtheme' | 'medilearntheme'

type QuestionsProps = {
  themeColor?: QuestionsThemeColor
}

const Questions = ({ themeColor = 'purple' }: QuestionsProps) => {
  const { questionsSection } = Constants

  const [openIndex, setOpenIndex] = useState<number | null>(null)

  const themeConfig: Record<QuestionsThemeColor, { itemTheme: SectionTheme }> = {
    purple: { itemTheme: 'default' },
    green: { itemTheme: 'greentheme' },
    rabbitx: { itemTheme: 'rabbitxtheme' },
    arbventure: { itemTheme: 'arbventuretheme' },
    tatvacaretheme: { itemTheme: 'lightpinktheme' },
    ddxtheme: { itemTheme: 'ddxtheme' },
    medilearntheme: { itemTheme: 'medilearntheme' },
  }
  const selectedTheme = themeConfig[themeColor] ?? themeConfig.purple

  const handleToggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index))
  }

  return (
    <div className="w-full rounded-3xl p-5 md:px-8 md:py-1 lg:py-2 xl:py-4 2xl:py-4 flex flex-col lg:min-h-[650px] xl:min-h-[620px] 2xl:h-[700px]">
      <h3 className={`text-2xl md:text-3xl font-rajdhani font-semibold ${themeColor === 'tatvacaretheme' ? 'text-black' : 'text-white'}`}>{questionsSection.header}</h3>

      <div className="mt-6 flex-1 overflow-y-auto flex flex-col gap-3 h-full [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
        {questionsSection.items.slice(0, 6).map((item, index) => (
          <QuestionItem
            key={`${item.question}-${index}`}
            question={item.question}
            answer={item.answer}
            theme={selectedTheme.itemTheme}
            isOpen={openIndex === index}
            onToggle={() => handleToggle(index)}
          />
        ))}
      </div>
    </div>
  )
}

export default Questions